export default __webpack_public_path__ + "static/media/logo-large.3f19b976.png";